import React from 'react'
import Backdrop from '../Backdrop/Backdrop'

import styles from './Modal.module.css'

const Modal = props => {
  return (
    <React.Fragment>
      <Backdrop 
        showModal={props.showModal}
        clicked={props.modalClosed}
      />
      <div 
        className={styles.modal}
        style={{
          transform: props.showModal ? 'scale(1)' : 'scale(0)'
        }}>
        {props.children}
      </div>
    </React.Fragment>
  )
}

export default Modal
